import { useEffect } from "react";

import EcommerceItem from "@/types/gtm/EcommerceItem";
import QuoteGtmEvent from "@/types/gtm/QuoteGtmEvent";

import { defaultQuoteData } from "./default-quote-event-data";

export interface ExtendedWindow extends Window {
  dataLayer?: QuoteGtmEvent[];
}

type PageLoadProps = {
  quoteData: Partial<QuoteGtmEvent | null>;
  policyItems: EcommerceItem[] | null;
  isReady: boolean;
};

const useGtmQuotePolicyOptions = (props: PageLoadProps) => {
  const { quoteData, policyItems, isReady } = props;
  useEffect(() => {
    const triggerPageLoadEvent = () => {
      if (quoteData !== null && policyItems !== null) {
        const extendedWindow = window as ExtendedWindow;
        extendedWindow.dataLayer = extendedWindow.dataLayer ?? [];

        const eventData = { ...defaultQuoteData, ...quoteData };
        if (eventData.ecommerce) eventData.ecommerce.items = policyItems;

        extendedWindow.dataLayer.push({
          ...eventData,
        });
      }
    };
    if (isReady) triggerPageLoadEvent();
    return () => {
      // Cleanup code if needed
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isReady]);
};

export default useGtmQuotePolicyOptions;
